<template>
  <div>
    <div class="main-site-card ba-mg-b-1">
      <div class="msc-content ba-card">
        <div class="msc-content-header">
          <div class="msc-content-info">
            <div class="msc-content-title">
              {{ config.title }}
            </div>
            <a
              v-if="canAccessWebsite"
              :href="`https://${accessWebsiteUrl}`"
              target="_blank"
              rel="noopener noreferrer"
              class="msc-content-link msc-content-link--published ba-flex ba-ai-center ba-gp-02"
            >
              {{ accessWebsiteLabel }}
              <builderall-icon code='6adb'></builderall-icon>
            </a>
            <span
              v-else
              class="msc-content-link msc-content-link--disabled ba-flex ba-ai-center ba-gp-02"
            >
              {{ displayWebsiteLabel }}
            </span>
          </div>
        </div>
        <div
          :style="`background-image: url('${siteBackgroundImage}');`"
          class="msc-content-image"
        >
          <div v-if="isUnpublish" class="box-badge unpublished">{{ $t('ct-unpublished') }}</div>
          <div v-else class="box-badge published">{{ $t('ct-published') }}</div>
          <div v-if="isStaticImport" class="box-badge imported">{{ $t('ct-imported') }}</div>
          <svg role="button" class="favorites-toggle" @click.prevent="updateFavorite" xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
            <path d="M8 0.5C8.33204 0.5 8.63305 0.714569 8.74316 1.03809L10.0156 4.77637L10.1309 5.11523H14.7139C15.0481 5.11523 15.3502 5.33087 15.459 5.65625C15.5681 5.98374 15.4559 6.34452 15.1865 6.55078L11.7646 9.1709L11.4883 9.38281L11.5918 9.71582L12.75 13.4609V13.4619C12.853 13.7944 12.731 14.1541 12.4521 14.3535C12.316 14.4507 12.1572 14.499 12 14.499C11.8348 14.499 11.6697 14.4464 11.5322 14.3418L11.5312 14.3408L8.30176 11.9004L8 11.6729L7.69824 11.9004L4.46875 14.3408C4.19539 14.5476 3.82406 14.5532 3.54688 14.3555H3.54785C3.26949 14.1564 3.14679 13.7949 3.25 13.4619V13.4609L4.4082 9.71777L4.51172 9.38574L4.23535 9.17383L0.813477 6.55078L0.719727 6.46582C0.519477 6.25456 0.446032 5.94512 0.541016 5.65918C0.651316 5.33058 0.953458 5.11523 1.28613 5.11523H5.86914L5.98438 4.77637L7.25684 1.03809C7.36695 0.714567 7.66796 0.5 8 0.5Z"
              :fill="config.is_favorite ? '#3099FF' : 'white'" stroke="#B4C4D7"/>
          </svg>
        </div>
        <div class="msc-content-footer">
          <template v-if="!isStaticImport">
            <router-link :to="{ name: 'Analytics', params: { id: config.encrypted_id } }" class="msc-content-footer-item visitors-count">
              <builderall-loader :loading="loadingViews" class="msc-visitors-loader">
                <span class="msc-content-footer-item-value">
                  {{ formattedTotalViews }}
                </span>
              </builderall-loader>
              <span class="msc-content-footer-item-title">
                {{ $t('ct-visitors') }}
              </span>
            </router-link>
            <hr class="ba-hr-column">
          </template>
          <div class="msc-content-footer-item active-domain">
            <span class="msc-content-footer-item-value ba-flex ba-ai-center ba-gp-02">
              <span :class="`ba-circle ${hasConnectedDomain ? 'ba-green' : 'ba-red'}`"></span>
              {{ hasConnectedDomain ? $t('ct-active-domain') : $t('ct-inactive-domain') }}
            </span>
            <router-link
              v-if="!hasConnectedDomain"
              :to="{ name: 'Domain', params: { id: config.encrypted_id } }"
              class="msc-connect-domain-link"
              @click.native="goToDomain"
            >
              {{ $t('ct-title-domain-popup') }}
            </router-link>
          </div>
          <hr v-if="config.sc_exists" class="ba-hr-column">
          <div v-else />
          <div v-if="config.sc_exists" class="msc-content-footer-item supercheckout">
            <button
              ba-tooltip-position="bottom"
              ba-tooltip-title="Supercheckout"
              class="ba-btn"
              @click="openSupercheckout()"
            >
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="12.5" fill="#EAF7EE" stroke="#00C38E"/><g clip-path="url(#clip0_5826_47374)"><path d="M9.91925 6.36816C8.77289 6.36816 7.78066 7.18858 7.56624 8.31462L7.09492 10.7892H6.55236C6.38767 10.7892 6.23172 10.8629 6.12709 10.99C6.02209 11.1167 5.97885 11.2834 6.0098 11.4448L7.19854 17.6849C7.41296 18.813 8.40246 19.6314 9.55083 19.6314H16.4494C17.5978 19.6314 18.5869 18.813 18.8017 17.6849L19.9904 11.4448C20.021 11.2834 19.9774 11.1167 19.8724 10.99C19.7678 10.8629 19.6118 10.7892 19.4471 10.7892H18.9046L18.4333 8.31462C18.2189 7.18858 17.2266 6.36816 16.0803 6.36816H9.91925ZM9.91925 7.47343H16.0803C16.7031 7.47343 17.231 7.90969 17.3474 8.52113V8.52185L17.7792 10.7892H8.22033L8.65208 8.52185V8.52113C8.76851 7.90971 9.29645 7.47343 9.91925 7.47343ZM12.0787 12.9998C12.3838 12.9998 12.6313 13.2474 12.6313 13.5524V16.8682C12.6313 17.1733 12.3838 17.4208 12.0787 17.4208C11.7736 17.4208 11.5261 17.1733 11.5261 16.8682V13.5524C11.5261 13.2474 11.7736 12.9998 12.0787 12.9998ZM13.9208 12.9998C14.2259 12.9998 14.4734 13.2474 14.4734 13.5524V16.8682C14.4734 17.1733 14.2259 17.4208 13.9208 17.4208C13.6158 17.4208 13.3682 17.1733 13.3682 16.8682V13.5524C13.3682 13.2474 13.6158 12.9998 13.9208 12.9998ZM9.91925 13.0026C10.1756 13.0269 10.3872 13.2259 10.4172 13.4912L10.7856 16.807C10.8191 17.1103 10.601 17.3834 10.2977 17.4172C10.2767 17.4195 10.2565 17.4208 10.2359 17.4208C9.95807 17.4208 9.71923 17.212 9.68755 16.9294L9.31913 13.6136C9.2856 13.3104 9.50379 13.0373 9.807 13.0034C9.84504 12.9994 9.88263 12.9992 9.91925 13.0026ZM16.0803 13.0026C16.1169 12.9992 16.1545 12.9994 16.1925 13.0034C16.4957 13.0373 16.7139 13.3104 16.6804 13.6136L16.312 16.9294C16.2803 17.212 16.0414 17.4208 15.7636 17.4208C15.743 17.4208 15.7228 17.4195 15.7018 17.4172C15.3985 17.3834 15.1804 17.1103 15.2139 16.807L15.5823 13.4912C15.612 13.2259 15.824 13.027 16.0803 13.0026Z" fill="#00C38E"/></g><defs><clipPath id="clip0_5826_47374"><rect width="14" height="14" fill="white" transform="translate(6 6)"/></clipPath></defs></svg>
            </button>
          </div>
          <div v-else />
          <website-actions
            class="box-options"
            :config="config"
            :page-home="pageHome"
            :website_type="website_type"
            :show="actionShow"
            @duplicate="duplicate"
            @publish="publish"
            @transfer="transfer"
            @unpublish="unpublish"
            @uploadImagePage="uploadImagePage"
          />
        </div>
      </div>
      <builderall-loader :loading="loadingTools" class="msc-connected-tools-loader">
        <div class="msc-connected-tools">
          <main-site-card-tool-status
            :href="getSocialProofCardUrl"
            :icon="'social-proof-pop-up'"
            :title="$t('ct-social-proof-popup')"
            :status="String(toolsConnected.builderall_socialproof.connected)"
          />
          <main-site-card-tool-status
            :href="getEmailRunningCardUrl"
            :icon="'email-marketing-5'"
            :title="$t('ct-email-running')"
            :status="String(toolsConnected.MailingBossFormComponent.connected)"
          />
          <main-site-card-tool-status
            :href="getCalendarConnectedCardUrl"
            :icon="'booking'"
            :title="$t('ct-calendar-connected')"
            :status="String(toolsConnected.BookingCalendarComponent.connected)"
          />
        </div>
      </builderall-loader>
    </div>
    <modal-upgrade-bundle ref="modal-upgrade-bundle"></modal-upgrade-bundle>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { duplicateWebsite, updateStatus, updateFavorite, getWebsiteTotalViews, getCachedWebsiteTotalViews, getWebsiteToolsConnected, getCachedWebsiteToolsConnected } from './../../../../js/services/editor/website';
import WebsiteActions from "./websites/WebsiteActions.vue";
import { apiUrl, auth as supercheckoutAuth } from '../../../../js/services/integrations-internas/supercheckout';
import ModalUpgradeBundle from '../../../dashboard/components/ModalUpgradeBundle.vue';
import MainSiteCardToolStatus from './MainSiteCardToolStatus.vue';
export default {
  name: 'MainSiteCardComponent',
  components: {
    WebsiteActions,
    ModalUpgradeBundle,
    MainSiteCardToolStatus,
  },

  props: ['website_type', 'config', 'categories', 'type_view', 'selectWebsites'],

  data() {
    return {
      pageHome: { configuration: {} },
      totalViews: null,
      loadingViews: false,
      currentViewsRequestId: null,
      toolsConnected: {
        builderall_socialproof: { connected: false },
        MailingBossFormComponent: { connected: false },
        BookingCalendarComponent: { connected: false },
      },
      loadingTools: false,
      currentToolsRequestId: null,
    };
  },

  computed: {
    actionShow() {
      if (this.isStaticImport)
      {
        return ['settings', 'eye', 'publish', 'edit'];
      }

      return ['settings', 'website-manager', 'eye', 'publish', 'edit'];
    },
    isStaticImport() {
      return this.config && this.config.type == 'static_import';
    },

    siteBackgroundImage() {
      if (this.pageHome.configuration && this.pageHome.configuration.og_image) {
        return this.pageHome.configuration.og_image;
      }
      if (this.config.thumbnail_portrait) {
        return this.config.thumbnail_portrait;
      }
      if (this.config.thumbnail) {
        return this.config.thumbnail;
      }
      return '/static/images/cheetah-og.png';
    },

    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com";
    },

    formattedTotalViews() {
      if (this.totalViews === null) return '0';

      return this.totalViews.toLocaleString();
    },
    accessWebsiteUrl() {
      const domain = this.config.access_url || this.config.dominio;

      if (!domain) return '';

      const cleanDomain = domain
        .replace(/^https?:\/\//i, '')
        .replace(/^\/+/, '');

      return `${cleanDomain}`;
    },

    accessWebsiteLabel() {
      if (this.config.dominio && this.config.domain_unicode)
        return this.config.domain_unicode;

      return this.accessWebsiteUrl;
    },

    isPublished() {
      return this.config.status === 'active';
    },

    getEmailRunningCardUrl() {
      return this.toolsConnected.MailingBossFormComponent.connected 
        ? `${this.officeUrl}/br/office/mailingboss-v2?redir=${process.env.MB_URL}%2Fcustomer%2Flists%3Fuid%3D${this.toolsConnected.MailingBossFormComponent.list_uid}%26resource_id%3Dmailingboss-list%26action%3Dedit` 
        : this.$t('ct-email-running-tutorial');
    },

    getCalendarConnectedCardUrl() {
      if (!this.toolsConnected.BookingCalendarComponent.connected) {
        return this.$t('ct-calendar-connected-tutorial');
      }
      try {
        const calendar_slug = new URL(this.toolsConnected.BookingCalendarComponent.calendar_src).pathname.replace('/embed/', '');
        return `${process.env.BOOKING_URL}/calendar/wizard/${calendar_slug}`;
      } catch (error) {
        return `${process.env.BOOKING_URL}`;
      }
    },

    getSocialProofCardUrl() {
      return this.toolsConnected.builderall_socialproof.connected 
        ? `${this.officeUrl}/br/office/new-social-proof?redir=%2Fcampaigns%3Fcampaign_id%3D${this.toolsConnected.builderall_socialproof.campaign_id}%26feature%3Danalytics` 
        : `${this.officeUrl}/br/office/new-social-proof?redir=%2Findex%3Ffeature%3Dcreate`
    },

    canAccessWebsite() {
      return this.isPublished && !!this.accessWebsiteUrl;
    },

    displayWebsiteLabel() {
      return this.accessWebsiteLabel || this.config.title || '';
    },

    hasConnectedDomain() {
      return !!this.config.dominio;
    },

    isUnpublish() {
      return this.config.status !== 'active';
    },

    isMirror() {
      return this.website_type === 'mirror';
    },
  },

  watch: {
    'config.encrypted_id': {
      immediate: true,
      handler(encryptedId) {
        this.homePage();

        if (encryptedId) {
          this.loadTotalViews(encryptedId);
          this.loadToolsConnected(encryptedId);
        }
      },
    },
  },

  methods: {
    ...mapGetters({ getUser: 'user' }),
    updateWebsites() {
      this.$emit('updateWebsites');
    },

    checkedSelectAll(website_id) {
      this.$emit('checkedSelectAll', website_id);
    },

    isExitPopupInBundleAccess() {
      return this.$isBundle() && this.config.is_exit_popup;
    },

    openEditSite() {
      // Se o usuário está no plano bundle e o site é de exit-popup devemos apresentar o upgrade modal
      if (this.isExitPopupInBundleAccess()) {
        this.$refs['modal-upgrade-bundle'].open();
        return;
      }

      let route = { href: ''};

      if(!this.pageHome.is_turbo) {
        route = this.$router.resolve({
          name: 'editor',
          params: {page_id: this.pageHome.encrypted_id}
        });
      } else {
        route = this.$router.resolve({
          name: 'CheetahTurboPageEdit',
          params: { id: this.pageHome.website.encrypted_id, page_id : this.pageHome.encrypted_id }
        });
      }

      window.open(route.href, '_blank');
    },

    goToSitePages() {
      this.$router.push({
        name: 'SitePages',
        params: { id: this.config.encrypted_id }
      });
    },

    goToDomain(event) {
      if (this.isExitPopupInBundleAccess()) {
        event.preventDefault();

        if (this.$refs['modal-upgrade-bundle']) {
          this.$refs['modal-upgrade-bundle'].open();
        }

        return;
      }
    },

    changeUnitary() {
      this.$emit('changeUnitary');
    },

    uploadImagePage(page) {
      this.$emit('uploadImagePage', page);
    },

    openSupercheckout() {
      if (this.$isBundle()) {
        this.$refs['modal-upgrade-bundle'].open();
        return;
      }

      supercheckoutAuth(this.config.id, this.config.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            return window.open(`${apiUrl()}?token=${token}`);
          } else
            this.$snotify.error('Supercheckout auth error');
        });
    },

    unpublish(status = 'inactive') {
      let data = {
        encrypted_id: this.config.encrypted_id,
        status: status
      };

      this.updateStatus(data);
    },

    updateStatus(data) {
      this.$loading.show();

      updateStatus(data)
        .then(() => {
          this.$loading.hide();
          this.updateWebsites();
        })
        .catch(() => {
          this.$loading.hide();
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your site, check the settings'
          );
        });
    },

    updateFavorite() {
      let data = {
        encrypted_id: this.config.encrypted_id,
        is_favorite: this.config.is_favorite ? '0' : '1'
      };

      this.$loading.show();

      updateFavorite(data)
        .then(() => {
          this.$loading.hide();
          this.$emit('updateFavorite', {
            site_id: this.config.id,
            is_favorite: !this.config.is_favorite
          })
        })
        .catch(() => {
          this.$loading.hide();
          this.$snotify.error(
            'Something happened when trying to favorite your site, check the settings'
          );
        });
    },

    duplicate() {
      this.$loading.show();

      duplicateWebsite(this.config)
        .then(data => {
          if (data.data.success === false)
            this.$snotify.warning(this.$t(data.data.error));

          this.updateWebsites();
          this.$snotify.success(this.$t('ct-duplicate-success'));
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 429) { // to many
              this.$snotify.error(this.$t('ct-too-many-attempts'));
            }
          }
        })
        .finally(() => this.$loading.hide());
    },

    transfer(show, config = '') {
      this.$emit('transfer', show, config);
    },

    publish(show) {
      this.$emit('publish', show, this.config);
    },

    getPageHome(data) {
      return data.find(page => !!page.initial);
    },

    homePage() {
      if (this.config.layouts && this.config.layouts[0] && this.config.layouts[0].pages && this.config.layouts[0].pages.length > 0) {
        let home = this.getPageHome(this.config.layouts[0].pages);
        this.pageHome = home || this.config.layouts[0].pages[0] || { configuration: {} };
      } else {
        this.pageHome = { configuration: {} };
      }
    },

    loadTotalViews(encryptedId) {

      if (this.isStaticImport) {
        this.totalViews = 0;
        this.loadingViews = false;
        return;
      }

      this.currentViewsRequestId = encryptedId;

      const cachedTotal = getCachedWebsiteTotalViews(encryptedId);

      if (cachedTotal !== null) {
        this.totalViews = cachedTotal;
        this.loadingViews = false;
        return;
      }

      this.totalViews = null;
      this.loadingViews = true;

      getWebsiteTotalViews(encryptedId)
        .then((total) => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.totalViews = total;
        })
        .catch(() => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.totalViews = 0;
        })
        .finally(() => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.loadingViews = false;
        });
    },

    loadToolsConnected(encryptedId) {
      this.currentToolsRequestId = encryptedId;

      const cachedTools = getCachedWebsiteToolsConnected(encryptedId);

      if (cachedTools !== null) {
        this.toolsConnected = cachedTools;
        this.loadingTools = false;
        return;
      }

      this.toolsConnected = {
        builderall_socialproof: { connected: false },
        MailingBossFormComponent: { connected: false },
        BookingCalendarComponent: { connected: false },
      };

      this.loadingTools = true;

      getWebsiteToolsConnected(encryptedId)
        .then((toolsConnected) => {
          if (this.currentToolsRequestId !== encryptedId) return;

          this.toolsConnected = toolsConnected;
        })
        .catch(() => {
          if (this.currentToolsRequestId !== encryptedId) return;
        })
        .finally(() => {
          if (this.currentToolsRequestId !== encryptedId) return;

          this.loadingTools = false;
        });
    },
  },
};
</script>

<style lang="scss">
.main-site-card {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 24px;
  align-items: center;

  .font-awesome-icon {
    width: 1em;
    height: 1em;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .box-options {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    grid-column: 6;
  }

  a {
    text-decoration: none;
  }

  .msc-content {
    overflow: visible;

    .msc-content-header {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      width: 100%;

      .msc-content-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
        .msc-content-title {
          font-size: 16px;
          font-weight: 700;
          color: #1E1E2D;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .msc-content-link {
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          builderall-icon {
            --builderall-icon-size: 12px;
          }

          &--published {
            color: #0072E1;
          }

          &--disabled {
            color: #8D9EB5;
            cursor: default;
          }
        }
      }

      /deep/ .box-options {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-shrink: 0;

        .btn-circle {
          width: 30px;
          height: 30px;
          background: transparent;
          color: #637183;
          margin-left: 12px;
          border: none;
          padding: 0;
          outline: unset;
          transition: all 0.3s;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          transform: rotate(90deg);

          .svg-icon,
          .svg-icon:after {
            width: 18px;
            height: 18px;
          }

          &:hover {
            color: #0072E1;
          }
        }

        .dropdown-toggle::after {
          display: none;
        }

        .dropdown-menu {
          z-index: 1050;
        }

        .font-awesome-icon {
          width: 1em;
          height: 1em;
        }
      }
    }
    .msc-content-image {
      width: 100%;
      height: 400px;
      border-radius: 16px;
      background-size: cover;
      background-position: 0 0;
      background-repeat: no-repeat;
      position: relative;
      padding: 12px;

      .favorites-toggle {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
      }
    }
    .msc-content-footer {
      display: grid;
      grid-template-columns: auto auto auto auto 1fr 1fr;
      align-items: center;
      gap: 16px;
      width: 100%;
      padding: 0 16px;
      hr {
        width: 2px;
        min-height: 22px;
        height: 22px;
      }
      .msc-content-footer-item {
        &.visitors-count {
          display: flex;
          flex-direction: column;
          .msc-visitors-loader {
            min-height: 22px;
            display: inline-flex;
            align-items: center;
          }
          .msc-content-footer-item-value {
            font-size: 18px;
            font-weight: 500;
            color: #3D3D3D;
          }
          .msc-content-footer-item-title {
            font-size: 12px;
            font-weight: 500;
            color: #8D9EB5;
          }
        }
        &.active-domain {
          display: flex;
          flex-direction: column;
          gap: 4px;
          .msc-content-footer-item-value {
            font-size: 14px;
            font-weight: 500;
            color: #4D5D71;
          }
          .msc-connect-domain-link {
            font-size: 12px;
            font-weight: 500;
            color: #0072E1;
            white-space: nowrap;
            margin-left: 12px;

            &:hover {
              text-decoration: underline;
            }
          }
        }
        &.supercheckout {
          position: relative;
          button {
            background: transparent;
            border: none;
            outline: none;
            border-radius: 100%;
          }
        }
        &.button-options {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          .ba-btn {
            &.website-manager {
              background-color: #EEF2F5;
              color: #8E9EB5;
              height: 100%;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .msc-connected-tools-loader {
    width: 100%;
  }
  .msc-connected-tools {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/MainSiteCard.vue